module.exports = __webpack_public_path__ + "files/e75b4efc6947e9ffad296eb58ca9a936.png";